module.exports = __webpack_public_path__ + "img/record.e71bc54a.png";